export const SELECT_REPOSITORY_TITLE = 'Select a repository'
export const GENERAL_CONVERSATIONS_HEADING = 'General conversations'
export const CHAT_DESCRIPTION = 'Ask questions and explore ideas with context you choose'
export const WORK_IN_REPOSITORY_HEADING = 'Work in a repository'
export const SEARCH_REPOSITORIES_PLACEHOLDER = 'Search repositories...'
